module.exports = __webpack_public_path__ + "img/[耶].a85e6e86.svg";